
import { required } from 'vuelidate/lib/validators'

export default {
  // Observacao precisamos ajustar para validat o CRM posteriomente
  credentials: {
    document: {
      required
    },
    state: {
      required
    },
    password: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/professional/resources/validations.js